import { Injectable } from '@angular/core';

import { Observable, defer, of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';

import { AppleRestrictionsProfilePresetsService, AppleRestrictionsProfilePreset } from '@rocksoft/mdm-sdk-v2';

@Injectable()
export class WifiProfileService {
  public readonly getWifiRestrictionsId$: Observable<string>;
  private readonly restrictionPreset: AppleRestrictionsProfilePreset;

  constructor(private readonly restrictionsApi: AppleRestrictionsProfilePresetsService) {
    this.restrictionPreset = {
      payloadDisplayName: 'Restrictions Profile',
      payloadIdentifier: 'com.methylium.restrictions',
      payloadType: 'com.apple.applicationaccess',
      payloadVersion: 1,
    };
    this.restrictionPreset.id = 'do_not_remove_era_wifi_restriction';
    this.restrictionPreset.payloadDescription =
      'Restrictions profile configures the device to use the specified Restrictions settings.';
    this.restrictionPreset.payloadOrganization = 'Methylium B.V.';
    this.restrictionPreset.payloadVersion = 1;
    this.restrictionPreset.forceWiFiWhitelisting = true;

    this.getWifiRestrictionsId$ = defer(() => this.restrictionsApi.getRestrictionsProfilePresets('2.0')).pipe(
      switchMap((restrictions) => {
        const index = restrictions.findIndex((restriction) => restriction.id === this.restrictionPreset.id);

        return index > -1
          ? of(restrictions[index])
          : this.restrictionsApi.addRestrictionsProfilePreset('2.0', this.restrictionPreset);
      }),
      map((restriction) => restriction.id)
    );
  }
}
